/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import {
  Segment, Dimmer, Loader, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import $ from 'jquery';
import cx from 'classnames';
import Update from 'immutability-helper';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import WithRouter from '../Extensions/WithRouter';
import RenderProjectTree from '../Extensions/RenderProjectTree';

class LitigatorDetail extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.litigatordetail = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      litigatorFileList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      activeIndex: [],
      securityTreeData: [],
      searchKeyword: '',
      isSort: false,
      sortValue: '2',
      idReport: this.props.params.idReport,
      popupIndex: [],
      popupType: '',
      isOpenMSF: false,
      scannedFileIds: [],
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposeLitigatorListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.litigatordetail) {
          this.getLitigatorfileList();
        }
      },
      {
        fireImmediately: true
      }
    );

    this.renderPopup();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;

    if (prevProps.params.idReport !== params.idReport) {
      this.setState(
        {
          idReport: params.idReport,
          litigatorFileList: [],
        },
        () => {
          this.getLitigatorfileList();
        }
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleOnScroll);
    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
    if (this.disposeLitigatorListReaction) {
      this.disposeLitigatorListReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        litigatorFileList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getLitigatorfileList(activePage, pageSize);
      });
    }
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleOnScroll = () => {
    const {
      getLitigatorfileList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getLitigatorfileList(this.state.currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        litigatorFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorfileList();
      }
    );
  };

  handleMoreInfo = (index) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState({
      popupIndex: newState,
      popupType: 'type_0',
    });
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (this.state.popupIndex.length !== 0 && this.state.popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handleOtherRisk = (index, ids) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState(
      {
        popupIndex: newState,
        popupType: 'type_1',
      },
      () => {
        this.getProjectTree(ids);
      }
    );
  };

  handleMSFClose = () => {
    this.setState({
      isOpenMSF: false,
    });
  };

  handleComponentFileModal = (sfids) => {
    this.setState({
      scannedFileIds: sfids,
      isOpenMSF: true,
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        litigatorFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorfileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      litigatorFileList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getLitigatorfileList(activePage, pageSize);
    });
  };

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          litigatorFileList: [],
          activeIndex: [],
        },
        () => {
          this.getLitigatorfileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          litigatorFileList: [],
          activeIndex: [],
        },
        () => {
          this.getLitigatorfileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      litigatorFileList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
    });
  };

  getLitigatorfileList = (pageNo, limit) => {
    let text;
    let precisionLevel;

    const {
      isSort, sortValue, litigatorFileList, pageSize
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (userStore.currentPrecisionLevel) {
      precisionLevel = userStore.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'litigator_name';
      } else {
        text = 'litigator_name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'component_count_r';
      } else {
        text = 'component_count';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'scanned_file_count_r';
      } else {
        text = 'scanned_file_count';
      }
      break;
    default:
      text = 'component_count';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getLitigatorfileList(
            {
              search: this.state.searchKeyword,
              page,
              limit: perPage,
              order: text,
              precision_level: precisionLevel,
            },
            this.state.idReport
          )
          .then((response) => {
            if (this.state.litigatorFileList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextLitigatorFileList = response.response.map((item) => {
              return {
                uploadedFileId: item.uploaded_file_id,
                litigatorName: item.litigator_name,
                componentCount: item.component_count,
                componentVersionCount: item.component_version_count,
                scannedFileCount: item.scanned_file_count,
                litigatorCode: item.litigator_code,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              litigatorFileList: [...litigatorFileList, ...nextLitigatorFileList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getLitigatorFileDetail = (litigatorCode) => {
    const { t } = this.props;
    let precisionLevel;

    if (this.props.state.user.currentPrecisionLevel) {
      precisionLevel = this.props.state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    this.setState({
      isDetailLoading: true,
      isVisible: litigatorCode,
    }, () => {
      api
        .getLitigatorFileDetail(
          {
            litigator_name: litigatorCode,
            precision_level: precisionLevel,
          },
          this.state.idReport
        )
        .then((response) => {
          const { litigatorFileList } = this.state;
          const data = response.response;
          const updatedIndex = litigatorFileList.findIndex((item) => {
            return item.litigatorCode === litigatorCode;
          });
          const updatedData = Update(litigatorFileList[updatedIndex], {
            litigatorDetail: { $set: data },
          });
          const newData = Update(litigatorFileList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            litigatorFileList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getProjectTree = (ufid) => {
    const { t } = this.props;
    const value = JSON.parse(`[${ufid}]`);
    const obj = {
      uploaded_file_ids: value,
    };
    api
      .getProjectTree(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 15) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 14 && tableEl.length > 15) || (i > 15 && (i - 14) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, litigatorCode) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getLitigatorFileDetail(litigatorCode);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      litigatorFileList: [],
      activeIndex: [],
    }, () => {
      this.getLitigatorfileList();
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        litigatorFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorfileList();
      }
    );
  };

  renderPopup = () => {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.card_detail_popup .table_type_1 .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  };

  renderTreeTable = (obj) => {
    let totalCount = 0;
    for (let i = 0; i < Object.keys(obj).length; i++) {
      const arr = obj[Object.keys(obj)[i]];
      for (let j = 0; j < arr.length; j++) {
        totalCount++;
      }
    }

    return (
      Object.keys(obj).map((groupDetail, k) => {
        return (
          obj[groupDetail].map((file, l) => {
            return (
              <tr className="" key={uuidv4()}>
                {
                  k === 0 && l === 0 ? (
                    <td className="tac border-bottom" rowSpan={totalCount}>
                      {file.component_name}
                    </td>
                  ) : null
                }
                {
                  l === 0 ? (
                    <td className="tac border-bottom" rowSpan={obj[groupDetail].length}>
                      {file.component_version}
                    </td>
                  ) : null
                }
                <td className="tac border-bottom has_link">
                  <span
                    onClick={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                  >
                    {file.scanned_file_name}
                  </span>
                </td>
              </tr>
            );
          })
        );
      })
    );
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      litigatorFileList,
      activeIndex,
      securityTreeData,
      isSort,
      sortValue,
      popupIndex,
      popupType,
      isDetailLoading,
      isVisible,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      searchKeyword,
      totalCount,
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    return (
      <div
        className="result_file"
        ref={this.litigatordetail}
      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          clearSearch={this.clearSearch}
          totalCount={totalCount}
          idReport={this.props.params.idReport}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}

        />
        <div className="content">
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '22.1%', maxWidth: '204px' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                            {t('list.title.litigator_code')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                            {t('list.title.scanned_file')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {litigatorFileList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                      },
                      {
                        type_0: popupType === 'type_0',
                      },
                      {
                        type_1: popupType === 'type_1',
                      }
                    )}
                    key={uuidv4()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '22.1%', maxWidth: '204px' }} />
                        <col style={{ width: '61.5%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.litigatorCode);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td className="border-none tal">
                            <strong>{item.litigatorName}</strong>
                          </td>
                          <td className="tal sum_td" colSpan="3">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{item.componentCount}</td>
                                  <td className="tac">{item.componentVersionCount}</td>
                                  <td className="tac">{item.scannedFileCount}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a
                              className="expand_button"
                            >
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.litigatorCode ? (
                            <tr>
                              <td className="border-none" colSpan="5">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.litigatorCode} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="checkbox_wrap border-none tal">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="3">
                                <Scrollbars
                                  style={{
                                    height: '440px',
                                    overflow: 'hidden',
                                    position: 'relative',
                                  }}
                                  renderTrackHorizontal={() => {
                                    return <div />;
                                  }}
                                  renderThumbHorizontal={() => {
                                    return <div />;
                                  }}
                                >
                                  {item.litigatorDetail
                                    && Object.keys(item.litigatorDetail.litigators).map((groupName) => {
                                      return (
                                        <table
                                          className="wide_card_table wide_card_item"
                                          key={uuidv4()}
                                        >
                                          <colgroup>
                                            <col style={{ width: '33%' }} />
                                            <col style={{ width: '33%' }} />
                                            <col style={{ width: '33%' }} />
                                          </colgroup>
                                          <tbody>
                                            {this.renderTreeTable(item.litigatorDetail.litigators[groupName])}
                                          </tbody>
                                        </table>
                                      );
                                    })}
                                </Scrollbars>
                              </td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.litigatorDetail ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top type_description">
                          <p className="description">Description</p>
                          <p className="version_text">{item.litigatorDetail.description}</p>
                        </div>
                        <div className="wide_card_detail_bottom">
                          <a
                            className={cx('card_detail_popup_show', {
                              active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleMoreInfo(index);
                            }}
                          >
                            {t('list.title.more_information')}
                          </a>
                          <a
                            className={cx('card_detail_popup_show', {
                              active: popupIndex.indexOf(index) >= 0 && popupType === 'type_1',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleOtherRisk(
                                index,
                                item.litigatorDetail.uploaded_file_ids
                              );
                            }}
                          >
                            {t('list.title.other_files_litigator')}
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {item.litigatorDetail && popupType === 'type_0' && (
                      <div className="card_detail_popup card_detail_popup_1">
                        <div className="popup_box">
                          <h3 className="popup_header">
                            {t('list.title.more_information')}
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handlePopupClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <div className="type_5">
                                <dl>
                                  <dt>
                                    {item.litigatorDetail.more_information.more_description.title}
                                  </dt>
                                  <dd>
                                    {item.litigatorDetail.more_information.more_description.text}
                                  </dd>
                                </dl>
                              </div>
                              {item.litigatorDetail.more_information.url && item.litigatorDetail.more_information.url.length !== 0 ? (
                                <div>
                                  <div className="line" />
                                  {item.litigatorDetail.more_information.url.map((urlList) => {
                                    return (
                                      <dl key={uuidv4()}>
                                        <dt>{urlList.title}</dt>
                                        <dd>
                                          <a
                                            href={urlList.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {urlList.url}
                                          </a>
                                        </dd>
                                      </dl>
                                    );
                                  })}
                                </div>
                              ) : null}
                              {item.litigatorDetail.more_information.inforce && item.litigatorDetail.more_information.inforce.length !== 0 ? (
                                <div>
                                  <div className="line" />
                                  <div>
                                    <dl>
                                      <dt>{t('list.title.current_projects')}</dt>
                                      <dd className="pink">
                                        <em>
                                          {item.litigatorDetail.more_information.inforce.title}
                                        </em>
                                      </dd>
                                    </dl>
                                    <table className="table_type_2">
                                      <colgroup>
                                        <col style={{ width: '50%' }} />
                                        <col style={{ width: '50%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <table>
                                              <tbody>
                                                {item.litigatorDetail.more_information.inforce.list.map(
                                                  (inforce, i) => {
                                                    return (
                                                      i % 2 === 0 && (
                                                        <tr key={uuidv4()}>
                                                          <td
                                                            style={{
                                                              border: '0',
                                                            }}
                                                          >
                                                            {inforce}
                                                          </td>
                                                        </tr>
                                                      )
                                                    );
                                                  }
                                                )}
                                              </tbody>
                                            </table>
                                          </td>
                                          <td>
                                            <table>
                                              <tbody>
                                                {item.litigatorDetail.more_information.inforce.list.map(
                                                  (inforce, i) => {
                                                    return (
                                                      i % 2 !== 0 && (
                                                        <tr key={uuidv4()}>
                                                          <td
                                                            style={{
                                                              border: '0',
                                                            }}
                                                          >
                                                            {inforce}
                                                          </td>
                                                        </tr>
                                                      )
                                                    );
                                                  }
                                                )}
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    )}
                    {securityTreeData.length !== 0 && popupType === 'type_1' && (
                      <div className="card_detail_popup card_detail_popup_2">
                        <div className="popup_box">
                          <h3 className="popup_header">
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handlePopupClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <RenderProjectTree
                                treeData={securityTreeData}
                                translate={t}
                                tableType={false}
                                state={state}
                              />
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && litigatorFileList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <ScannedFilesInfoModal
          isOpenMSF={this.state.isOpenMSF}
          closeModal={this.handleMSFClose}
          ufid={this.state.idReport}
          scannedFileIds={this.state.scannedFileIds}
          translate={t}
        />
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LitigatorDetail))));
